import React, { useState, useEffect } from 'react';
import businessUnitService from '../../../../services/businessUnitService';

/**
 * Component to display a business unit name from its ID
 * Automatically fetches and displays the name from the businessUnitService
 * Special case: displays "Various Business Units" when ID is "9999"
 */
const BusinessUnitName = ({ id, className = '', fallback = '-' }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(true);

  // Fetch the business unit name when the ID changes
  useEffect(() => {
    let isMounted = true;
    
    const fetchBusinessUnitName = async () => {
      if (!id) {
        setName(fallback);
        setLoading(false);
        return;
      }
      
      // Special case: ID is 9999
      if (id === 9999 || id === "9999") {
        setName("Various Business Units");
        setLoading(false);
        return;
      }
      
      try {
        setLoading(true);
        const businessUnitName = await businessUnitService.getBusinessUnitName(id);
        
        // Only update state if component is still mounted
        if (isMounted) {
          setName(businessUnitName || fallback);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error fetching business unit name:', error);
        if (isMounted) {
          setName(String(id) || fallback); // Fallback to ID if error
          setLoading(false);
        }
      }
    };

    fetchBusinessUnitName();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [id, fallback]);

  // Show a loading indicator or the name
  return (
    <span className={className}>
      {loading ? (
        <span className="inline-block w-16 h-4 bg-slate-600 animate-pulse rounded"></span>
      ) : (
        name
      )}
    </span>
  );
};

export default BusinessUnitName;